module.exports = __webpack_public_path__ + "static/img/s8.a12cefe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/s8.png
// module id = FM7j
// module chunks = 1